export default process.env.NODE_ENV != "production"
  ? {
      node_api_endpoint: "http://192.168.1.193:3002",
      // node_api_endpoint: "http://192.168.0.95:3002",
      // node_api_endpoint: "https://digiapi.escrowstack.io",
    }
  : {
      node_api_endpoint: "https://digiapi.escrowstack.io",
    };
